import { Input } from "antd";
import React, { useEffect, useRef, useState } from "react";

import { apiCall } from "../utils/Api";
import { filterUnique, sortAlpha } from "../utils/Utils";

export default function FilterAutocomplete(props) {
    const inputRef = useRef();
    const {
        filters = [],
        facet_row_counts = {},
        setFilters,
        name = "",
        searchFilters = [],
        initialMessage = true,
        setInitialMessage = () => { },
        setPublisherMaxRows = () => { },
    } = props;
    const [initFilters, setInitFilters] = useState([]);
    const local = (name === "publisher_imprint") ? false : true;

        const rows = filters.find(f => f.name === name)?.rows ?? [];
   const searchLocal = (_search, ifilters) => {

        if(!_search){
            setFilters(ifilters);
            return; 
        }
        
        let index = ifilters.findIndex(item => item.name === name);

        if (index > -1) {
            let _f = ifilters.map(item => {
                return {...item}
            });

            
            _f[index].rows = sortAlpha(filterUnique(_f[index].rows.filter(item => item.name.toUpperCase().includes(_search.toUpperCase()) && item.key !== "--"), "name"), "name")
            
            console.log(_f[index].rows);
            setFilters(_f);           
        }


    }

    useEffect(() => {
        // Clear inputs when searchFilters change
        if(inputRef.current && inputRef.current.state){
            inputRef.current.state.value = "";
        }
    }, [searchFilters])

    const onChange = (_search) => {
        // ensure init is set
        let ifilters = initFilters;
        if (filters.length > initFilters.length) {
            ifilters = filters.map(item => {
                return { ...item }
            });
            setInitFilters(ifilters);
        }
        if (!_search) {
            setFilters(ifilters);
        }
        if (local) {
            return searchLocal(_search, ifilters);
        }
        apiCall("browse/getAutocompleteFacets", { search_filters: JSON.stringify(searchFilters), filter_name: "publisher_imprint", search_term: _search }, (_status, _result) => {
            if (_status) {
                let index = ifilters.findIndex(item => item.name === name);
                if (index > -1) {
                    let _f = [...ifilters]
                    _f[index].rows = _result.rows;
                    if (_result.name === "publisher_imprint") {
                        setPublisherMaxRows(_result.max_rows)
                    }
                    setFilters(_f);
                }
            }
        })
    }

      const fetchLots = () => {
        apiCall("browse/getAutocompleteFacets", { filter_name: "publisher_imprint", search_term: "", limit: 500, search_filters: JSON.stringify(searchFilters) }, (_status, _result) => {
            if (_status) {

                let index = filters.findIndex(item => item.name === name);
                if (index > -1) {
                    let _f = [...filters];
                    _f[index].rows = _result.rows;
                    setFilters(_f)
                }
            }
        })
    }

     const { publisher_imprint = 0 } = facet_row_counts;
    return (
        <>
            <div className="shim" />
            <Input
                ref={inputRef}
                allowClear
                onChange={(e) => {
                    onChange(e.target.value);
                    if (initialMessage) {
                        setInitialMessage(false);
                    }
                }}
                onKeyDown={(e) => {
                    if (name === "publisher_imprint") {
                        if (e.key === "Enter") {
                            if (initialMessage) {
                                setInitialMessage(false);
                            }
                            onChange(e.target.value);
                        }
                    } else {
                        onChange(e.target.value)
                    }
                }}
                style={{ "fontSize": "12px" }}
                size="small"
                placeholder={name === "publisher_imprint" ? "Search..." : "Refine..."}
            />

             {(!local && initFilters.length === 0 && publisher_imprint > 0 && rows.length !== 500 && publisher_imprint > rows.length && <>
                <div className="float-flex">
                    <div className="c"><small>Showing {rows.length} of {(publisher_imprint > 5000) ? "thousands" : publisher_imprint}</small></div>
                    <div className="c"><small><a onClick={() => fetchLots()}>{(publisher_imprint > 501) ? "Load 500" : "Load all " + publisher_imprint}</a></small></div>
                </div>
            </>)}


        </>
    )
}